/**
 * Returns the GUYANA states list to populate the select item.
 */
export function gluky_addressfield_gy_states_list() {
  let temporalStates = [];
  const states =
  {
    '00': 'Barima-Waini',
    '01': 'Cuyuni-Mazaruni',
    '02': 'Demerara-Mahaica',
    '03': 'East Berbice-Corentyne',
    '04': 'Essequibo Islands-West Demerara',
    '05': 'Mahaica-Berbice',
    '06': 'Pomeroon-Supenaam',
    '07': 'Potaro-Siparuni',
    '08': 'Upper Demerara-Berbice',
    '09': 'Upper Takutu-Upper Essequibo',
  }

  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Guyana cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
export function gluky_addressfield_gy_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '00': {
      '0001': 'Arakaka',
      '0002': 'Baramita',
      '0003': 'Hosororo',
      '0004': 'Koriabo',
      '0005': 'Mabaruma',
      '0006': 'Matthews Ridge',
      '0007': 'Morawhanna',
      '0008': 'Moruca',
      '0009': 'Port Kaituma',
      '0010': 'Towakaima',
    },
    '01': {
      '0101': 'Arimu Mine',
      '0102': 'Bartica',
      '0103': 'Imbaimadai',
      '0104': 'Issano',
      '0105': 'Isseneru',
      '0106': 'Kamarang',
      '0107': 'Kamikusa',
      '0108': 'Kartuni',
      '0109': 'Keweigek',
      '0110': 'Peters Mine',
      '0111': 'Tumereng',
    },
    '02': {
      '0201': 'Buxton',
      '0202': 'Enmore',
      '0203': 'Enterprise',
      '0204': 'Georgetown',
      '0205': 'Hyde Park',
      '0206': 'Paradise',
      '0207': 'Victoria',
    },
    '03': {
      '0301': 'Corriverton',
      '0302': 'Mara',
      '0303': 'New Amsterdam',
      '0304': 'Orealla',
      '0305': 'Port Mourant',
      '0306': 'Rose Hall',
    },
    '04': {
      '0401': 'Hog Island',
      '0402': 'Leguan',
      '0403': 'Parika',
      '0404': 'Schoon Ord',
      '0405': 'Uitvlugt',
      '0406': 'Wakenaam',
      '0407': 'Zeeburg',
    },
    '05': {
      '0501': 'Fort Washington',
      '0502': 'Helena',
      '0503': 'Mahaicony',
      '0504': 'Rosignol',
    },
    '06': {
      '0601': 'Adventure',
      '0602': 'Anna Regina',
      '0603': 'Charity',
      '0604': 'Pickersgill',
      '0605': 'Spring Garden',
      '0606': 'Suddie',
    },
    '07': {
      '0701': 'Kangaruma',
      '0702': 'Mahdia',
      '0703': 'Orinduik',
      '0704': 'Oringuik',
      '0705': 'Potaro Landing',
      '0706': 'Saveretik',
      '0707': 'Tumatumari',
    },
    '08': {
      '0801': 'Ituni',
      '0802': 'Kalkuni',
      '0803': 'Kurupakari',
      '0804': 'Kwakwani',
      '0805': 'Linden',
      '0806': 'Rockstone',
      '0807': 'Takama',
    },
    '09': {
      '0901': 'Aishalton',
      '0902': 'Annai',
      '0903': 'Apoteri',
      '0904': 'Good Hope',
      '0905': 'Isherton',
      '0906': 'Lethem',
      '0907': 'Surama',
      '0908': 'Wichabai',
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

